import components from "../components";
import replaced_components from "../replaced_components";
import issues from "../issues";

export default {
  components: components,
  replaced_components: replaced_components,
  issues: issues,
};
